var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39924 7.83266C4.15162 7.47574 3.66983 7.39305 3.32313 7.64796C2.97643 7.90288 2.89611 8.39887 3.14373 8.75579C3.83815 9.75674 4.67309 10.6318 5.61656 11.3505L4.44648 13.8819C4.26342 14.278 4.42689 14.7518 4.8116 14.9403C5.19631 15.1287 5.65658 14.9604 5.83965 14.5644L6.92829 12.2091C6.9659 12.2301 7.00364 12.2507 7.04151 12.2712C8.3491 12.978 9.7725 13.3974 11.2288 13.5071V15.7058C11.2288 16.1444 11.5741 16.5 12.0002 16.5C12.4262 16.5 12.7716 16.1444 12.7716 15.7058V13.5071C14.2277 13.3974 15.651 12.9779 16.9585 12.2712C16.9961 12.2509 17.0335 12.2304 17.0708 12.2096L18.161 14.5668C18.3442 14.9628 18.8045 15.1309 19.1891 14.9424C19.5738 14.7538 19.7372 14.2799 19.554 13.8839L18.3826 11.3512C19.3264 10.6323 20.1616 9.75705 20.8563 8.75579C21.1039 8.39887 21.0236 7.90288 20.6769 7.64796C20.3302 7.39305 19.8484 7.47574 19.6008 7.83266C18.7112 9.11486 17.5603 10.152 16.2413 10.8649C14.9354 11.5708 13.499 11.9405 12.0432 11.9477C12.029 11.9469 12.0146 11.9465 12.0002 11.9465C11.9857 11.9465 11.9714 11.9469 11.9571 11.9477C10.5012 11.9406 9.0647 11.5709 7.75873 10.8649C7.51437 10.7329 7.27576 10.5896 7.04353 10.4358C7.02529 10.4224 7.00636 10.4098 6.98675 10.3979C5.98894 9.72647 5.11052 8.8579 4.39924 7.83266Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closed-eye.5b30f050.svg";
export { ForwardRef as ReactComponent };